import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import logo from '../../assets/images/logo/tsp-logo.png';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="footer__container container">
      <div className="footer__grid">
        <div className="footer__brand">
          <img src={logo} alt="Tokyo Steel Philippines" className="footer__logo" />
          <p className="footer__tagline">TSP exists to connect your innovations!</p>
          <p className="footer__desc">One of the first manufacturers of ultra precise stainless steel shafts in the Philippines. ISO Certified since 2007.</p>
        </div>
        <div className="footer__nav">
          <h4 className="footer__heading">Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/products">Products</Link></li>
            <li><Link to="/cutting-process">Cutting Process</Link></li>
            <li><Link to="/escomatic-process">Escomatic Process</Link></li>
            <li><Link to="/quality-assurance">Quality Assurance</Link></li>
            <li><Link to="/awards">Awards</Link></li>
          </ul>
        </div>
        <div className="footer__contact">
          <h4 className="footer__heading">Contact Info</h4>
          <ul>
            <li><FaMapMarkerAlt className="footer__icon" /><span>5th Street corner 3rd Avenue MEPZ 1, Ibo, Lapu-Lapu City, Cebu, Philippines</span></li>
            <li><FaPhoneAlt className="footer__icon" /><span>+63-32-340-3753 / +63-32-344-5038</span></li>
            <li><FaEnvelope className="footer__icon" /><span>prod_sales@tokyosteel.com.ph</span></li>
          </ul>
        </div>
      </div>
      <div className="footer__bottom"><p>&copy; {new Date().getFullYear()} Tokyo Steel Philippines Corporation. All Rights Reserved.</p></div>
    </div>
  </footer>
);

export default Footer;
